import {combineReducers} from 'redux';

function article(state = {labels: [], content: ''}, action) {
  switch (action.type) {
    case 'FETCH_POST_SUCCESS':
      return action.data;
    default:
      return state;
  }
}

function loading(state = false, action) {
  switch (action.type) {
    case 'FETCH_POSTS_REQUEST':
      return true;
    case 'FETCH_POSTS_ERROR':
    case 'FETCH_POSTS_SUCCESS':
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  article,
  loading
});



// WEBPACK FOOTER //
// ./reducers/post.js